import React from 'react';

function StartingTheChat() {
  return (
    <>
      <li>
        Press <b>Tab</b> until the "Start chat" button is in focus and press{' '}
        <b>Enter</b>.
      </li>
      <li>Focus moves to the "Type your message" box automatically.</li>
    </>
  );
}

function AskingAQuestion() {
  return (
    <>
      <li>
        Type your question and press <b>Enter</b> to send it.
      </li>
      <li>The chatbot’s reply is read out loud automatically.</li>
    </>
  );
}

function ReviewingMessages() {
  return (
    <>
      <li>
        With the message box empty, press the <b>up arrow</b> key to move to the
        latest message.
      </li>
      <li>
        Use the <b>up and down arrow</b> keys to move between messages.
      </li>
      <li>
        Press <b>Home</b> or <b>End</b> to jump to the first or last message.
      </li>
    </>
  );
}

function ChoosingATopic() {
  return (
    <>
      <li>
        When the chatbot offers topic options, focus moves to the first option
        automatically.
      </li>
      <li>
        Press <b>Tab</b> to move between options and press <b>Enter</b> to
        select one.
      </li>
    </>
  );
}

function UsingLinks() {
  return (
    <>
      <li>
        With a message in focus, press <b>Enter</b> to move to the links and
        buttons inside it.
      </li>
      <li>
        Press <b>Tab</b> to move between them and press <b>Enter</b> to open a
        link. The link will open in a new tab.
      </li>
    </>
  );
}

function Exiting() {
  return (
    <>
      <li>
        Press <b>Escape</b> to step back: from a link or option to its message,
        and from a message to the message box.
      </li>
      <li>
        To move elsewhere on the page, use your screen reader’s landmark
        commands. The chatbot is listed as a region named "VA chatbot (beta)".
      </li>
    </>
  );
}

export default function ScreenReader() {
  return (
    <>
      <h4 slot="headline">How to use our chatbot with a screen reader</h4>
      <p>
        If you’re blind or have low vision, follow these steps to use our
        chatbot on a desktop computer with a screen reader:
      </p>

      <ol>
        <StartingTheChat />
        <AskingAQuestion />
        <ReviewingMessages />
        <ChoosingATopic />
        <UsingLinks />
        <Exiting />
      </ol>

      <p>
        <b>Note:</b> We’re currently in beta testing. Thank you for your
        patience as we work to make our chatbot easier to use.
      </p>
    </>
  );
}
